import React, { useEffect, useState } from 'react'
import { CircularProgress, Grid, Typography } from '@material-ui/core'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import useStyles from './styles'

export const DetailPanel = (props) => {
  const { idExameSelecionado } = props
  moment.locale('pt-br', localization)
  const exameRealizadoService = useExameRealizadoService()
  const [processandoExame, setProcessandoExame] = useState(false)
  const [exameRealizado, setExameRealizado] = useState(null)
  const classes = useStyles()

  useEffect(() => {
    const fetchExameRealizado = async () => {
      const response = await exameRealizadoService.listarExameRealizadoDetalhadoAsync(
        idExameSelecionado,
        setProcessandoExame
      )
      setExameRealizado(response)
    }

    if (idExameSelecionado && idExameSelecionado >= 0) {
      fetchExameRealizado()
    }
  }, [idExameSelecionado])

  return (
    <div>
      {processandoExame || !exameRealizado ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container className={classes.container} spacing={1}>
          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Caso relacionado</Typography>
            <Typography className={classes.value}>
              {exameRealizado.exSol?.solEx?.caso?.identificador || '-'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Procedimento</Typography>
            <Typography className={classes.value}>
              {exameRealizado.exSol?.solEx?.tipoProc
                ? `${exameRealizado.exSol.solEx.tipoProc.nome}: ${exameRealizado.exSol.solEx.numeroProcedimento}`
                : 'Não informado'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Solicitante</Typography>
            <Typography className={classes.value}>
              {exameRealizado.exSol?.solEx?.autReq
                ? `${exameRealizado.exSol.solEx.autReq.nome}${
                    exameRealizado.exSol.solEx.autReq.cargo
                      ? ` - ${exameRealizado.exSol.solEx.autReq.cargo.nome.toUpperCase()}`
                      : ''
                  }`
                : 'Não informado'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Setor responsável</Typography>
            <Typography className={classes.value}>
              {exameRealizado.exSol?.setor
                ? `${exameRealizado.exSol.setor.nome} / ${exameRealizado.exSol.setor.divisao?.sigla} / ${exameRealizado.exSol.setor.divisao?.regional?.sigla} / ${exameRealizado.exSol.setor.divisao?.regional?.orgao?.sigla}`
                : '-'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Examinadores</Typography>
            <Typography className={classes.value}>
              {exameRealizado.usuExams && exameRealizado.usuExams.length
                ? exameRealizado.usuExams.map((examinador) => examinador.nome).join(', ')
                : 'Nenhum examinador atribuído'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Data da atribuição</Typography>
            <Typography className={classes.value}>
              {exameRealizado.dataInicio
                ? moment(exameRealizado.dataInicio).format('LLLL')
                : 'Não iniciado'}
            </Typography>
          </Grid>
        </Grid>
      )}
    </div>
  )
}
